var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Signup Dev Tools")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{ path: 'market-links/'},"append":""}},[_vm._v("\n                Market Links\n            ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }